/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';
import {
    PrtimesMediaListsMediaOutletsSearchResponseAllOf,
    PrtimesMediaListsMediaOutletsSearchResponseAllOfFromJSON,
    PrtimesMediaListsMediaOutletsSearchResponseAllOfFromJSONTyped,
    PrtimesMediaListsMediaOutletsSearchResponseAllOfToJSON,
} from './PrtimesMediaListsMediaOutletsSearchResponseAllOf';
import {
    SearchResultPrtimesMediaOutlet,
    SearchResultPrtimesMediaOutletFromJSON,
    SearchResultPrtimesMediaOutletFromJSONTyped,
    SearchResultPrtimesMediaOutletToJSON,
} from './SearchResultPrtimesMediaOutlet';

/**
 * response of POST /prtimes_media_lists/media_outlets/search
 * @export
 * @interface PrtimesMediaListsMediaOutletsSearchResponse
 */
export interface PrtimesMediaListsMediaOutletsSearchResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PrtimesMediaListsMediaOutletsSearchResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PrtimesMediaListsMediaOutletsSearchResponse
     */
    message: string;
    /**
     * 検索結果のメディアの総数
     * @type {number}
     * @memberof PrtimesMediaListsMediaOutletsSearchResponse
     */
    totalCount: number;
    /**
     * 指定範囲のメディア一覧
     * @type {Array<SearchResultPrtimesMediaOutlet>}
     * @memberof PrtimesMediaListsMediaOutletsSearchResponse
     */
    prtimesMediaOutlets: Array<SearchResultPrtimesMediaOutlet>;
}

export function PrtimesMediaListsMediaOutletsSearchResponseFromJSON(json: any): PrtimesMediaListsMediaOutletsSearchResponse {
    return PrtimesMediaListsMediaOutletsSearchResponseFromJSONTyped(json, false);
}

export function PrtimesMediaListsMediaOutletsSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListsMediaOutletsSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'totalCount': json['total_count'],
        'prtimesMediaOutlets': ((json['prtimes_media_outlets'] as Array<any>).map(SearchResultPrtimesMediaOutletFromJSON)),
    };
}

export function PrtimesMediaListsMediaOutletsSearchResponseToJSON(value?: PrtimesMediaListsMediaOutletsSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'total_count': value.totalCount,
        'prtimes_media_outlets': ((value.prtimesMediaOutlets as Array<any>).map(SearchResultPrtimesMediaOutletToJSON)),
    };
}

